// src/i18n/fr.js
// Traductions françaises - NE PAS MODIFIER

const fr = {
  // Navigation
  nav: {
    recent: 'Récents',
    explorer: 'Explorer',
    favorites: 'Favoris',
    voyages: 'Voyages',
    social: 'Social',
    messages: 'Messages',
    profile: 'Profil',
  },

  // Catégories
  categories: {
    sejours: 'Séjours',
    locations: 'Locations',
    immobilier: 'Immobilier',
    parcelles: 'Parcelles & Propriétés',
    services: 'Services',
  },

  // Descriptions de sections (accueil)
  sections: {
    premiumTitle: 'Annonces à la une',
    premiumDesc: 'Sélectionnées et mises en avant',
    sejoursTitle: 'Séjours courte durée',
    sejoursDesc: 'Hôtels, studios meublés et chambres',
    locationsTitle: 'Locations longue durée',
    locationsDesc: 'Appartements et maisons au mois',
    immobilierTitle: 'Parcelles & Propriétés',
    immobilierDesc: 'Terrains et biens à vendre',
    servicesTitle: 'Services',
    servicesDesc: 'Nettoyage, déménagement, rénovation',
    seeAll: 'Voir tout',
  },

  // Home
  home: {
    title: 'Fynho',
    recentTitle: 'Consultées récemment',
    recentDesc: 'Reprenez là où vous vous étiez arrêtés',
    heroTitlePart1: 'Trouvez votre',
    heroTitleHighlight: 'nouveau chez-vous',
    heroSubtitle: 'Séjours, locations, terrains et services partout au Cameroun.',
    searchPlaceholder: 'Ville, quartier, type de bien...',
    useLocation: 'Rechercher à proximité',
    featured: 'Annonces à la une',
    viewMap: 'Carte',
    noResults: 'Aucun résultat trouvé',
    listing: 'annonce',
    listings: 'annonces',
    footerTagline: 'Find Your New Home',
  },

  // Listing
  listing: {
    price: 'Prix',
    bedroom: 'Chambre',
    bedrooms: 'Chambres',
    bathroom: 'Salle de bain',
    bathrooms: 'Salles de bain',
    area: 'Superficie',
    capacity: 'Capacité',
    person: 'personne',
    persons: 'personnes',
    perNight: 'par nuit',
    perMonth: 'par mois',
    perSquareMeter: 'par m²',
    amenities: 'Équipements',
    photos: 'Photos',
    description: 'Description',
    location: 'Localisation',
    contact: 'Contact',
    phone: 'Téléphone',
    whatsapp: 'WhatsApp',
    reserve: 'Réserver',
    addToFavorites: 'Ajouter aux favoris',
    removeFromFavorites: 'Retirer des favoris',
    share: 'Partager',
    report: 'Signaler',
    viewOnMap: 'Voir sur la carte',
    distance: 'à',
    distanceKm: 'km',
  },

  // Réservation
  reservation: {
    title: 'Demander une réservation',
    fullName: 'Nom complet',
    phone: 'Téléphone ou WhatsApp',
    email: 'Email',
    checkInDate: 'Date d\'arrivée',
    checkOutDate: 'Date de départ',
    numberOfGuests: 'Nombre de personnes',
    message: 'Message (optionnel)',
    submit: 'Envoyer la demande',
    success: 'Réservation envoyée avec succès!',
    error: 'Erreur lors de l\'envoi de la réservation',
    terms: 'J\'accepte les conditions d\'utilisation',
  },

  // Admin
  admin: {
    dashboard: 'Tableau de bord',
    listings: 'Annonces',
    reservations: 'Réservations',
    owners: 'Propriétaires',
    users: 'Utilisateurs',
    admins: 'Administrateurs',
    quartiers: 'Quartiers',
    types: 'Types d\'annonces',
    reviews: 'Avis',
    reports: 'Signalements',
    stats: 'Statistiques',
    auditLogs: 'Logs d\'audit',
    add: 'Ajouter',
    edit: 'Modifier',
    delete: 'Supprimer',
    approve: 'Approuver',
    reject: 'Rejeter',
    view: 'Voir',
    actions: 'Actions',
    status: 'Statut',
  },

  // Statuts
  status: {
    draft: 'Brouillon',
    pending: 'En attente',
    published: 'Publié',
    rejected: 'Rejeté',
    disabled: 'Désactivé',
    new: 'Nouvelle demande',
    contacted: 'Contacté',
    confirmed: 'Confirmé',
    cancelled: 'Annulée',
    archived: 'Archivée',
  },

  // Messages communs
  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Attention',
    info: 'Information',
    ok: 'OK',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    close: 'Fermer',
    back: 'Retour',
    next: 'Suivant',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    search: 'Rechercher',
    filter: 'Filtrer',
    sort: 'Trier',
    noData: 'Aucune donnée',
    tryAgain: 'Réessayer',
    language: 'Langue',
    theme: 'Thème',
    themeDark: 'Sombre',
    themeLight: 'Clair',
    settings: 'Paramètres',
    help: 'Aide',
    support: 'Support',
    logout: 'Déconnexion',
    all: 'Tout',
  },

  // Erreurs
  errors: {
    required: 'Ce champ est obligatoire',
    invalidEmail: 'Email invalide',
    invalidPhone: 'Numéro de téléphone invalide',
    minLength: 'Minimum {min} caractères',
    maxLength: 'Maximum {max} caractères',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    networkError: 'Erreur réseau. Vérifiez votre connexion.',
    serverError: 'Erreur serveur. Réessayez plus tard.',
    notFound: 'Ressource non trouvée.',
    unauthorized: 'Authentification échouée.',
    forbidden: 'Accès refusé.',
    validationError: 'Vérifiez les données saisies.',
  },

  // Quartiers (exemples)
  quartiers: {
    bonapriso: 'Bonapriso',
    bastos: 'Bastos',
    akwa: 'Akwa',
    bonanjo: 'Bonanjo',
    douala: 'Douala',
    yaounde: 'Yaoundé',
    bafoussam: 'Bafoussam',
    kumba: 'Kumba',
  },
  settings: {
    account: 'Compte',
    general: 'Général',
    permissions: 'Permissions de l\'appareil',
    themeColor: 'Couleur du thème',
    about: 'À propos',
    darkTheme: 'Thème sombre',
    geolocation: 'Géolocalisation',
    notifications: 'Notifications',
    shareApp: 'Partager Fynho',
    helpSupport: 'Aide & Support',
    loginPrompt: 'Connectez-vous pour sauvegarder vos favoris et avis.',
    login: 'Se connecter',
    logout: 'Déconnexion',
    confirmLogout: 'Se déconnecter ?',
    geoActive: 'Activé',
    geoBlocked: 'Bloqué',
    geoInactive: 'Désactivé',
    notifActive: 'Activées',
    notifBlocked: 'Bloquées',
    notifInactive: 'Non activées',
    notifUnsupported: 'Non disponible',
    notifNeedsInstall: 'Nécessite l\'installation',
    iosNotifHint: 'Sur iPhone, les notifications ne fonctionnent que si Fynho est installée sur votre écran d\'accueil. Ouvrez le menu de partage de Safari (icône ⬆️) puis "Sur l\'écran d\'accueil".',
    generalHint: 'La géolocalisation vous montre les annonces proches de vous. Les notifications vous alerteront bientôt des mises à jour de vos favoris et avis.',
    privacyPolicy: 'Politique de confidentialité',
    deleteAccount: 'Supprimer mon compte',
  },
  support: {
    heroTitle1: 'Find Your',
    heroTitle2: 'New Home',
    heroSubtitle: 'La plateforme immobilière camerounaise pour trouver séjours, locations, terrains et services, en toute confiance.',
    adv1Title: 'Annonces vérifiées',
    adv1Text: 'Chaque bien publié sur Fynho est contrôlé par notre équipe avant sa mise en ligne.',
    adv2Title: 'Recherche géolocalisée',
    adv2Text: 'Trouvez instantanément les logements, terrains et services les plus proches de vous.',
    adv3Title: 'Contact direct et rapide',
    adv3Text: 'Écrivez-nous en un clic sur une annonce, nous vous répondons dans les meilleurs délais.',
    adv4Title: 'Pensé pour le Cameroun',
    adv4Text: 'Séjours, locations, terrains et services à Douala, Yaoundé et dans toutes les grandes villes.',
    needHelp: 'Besoin d\'aide ?',
    faqTitle: 'Questions fréquentes',
    faq1q: 'Comment contacter une annonce ?',
    faq1a: 'Ouvrez une annonce et appuyez sur "Contacter". Vous pouvez écrire sur WhatsApp ou appeler directement.',
    faq2q: 'Le paiement se fait-il sur l\'app ?',
    faq2a: 'Non. Aucun paiement ne passe par Fynho. Le règlement se fait toujours directement avec le contact indiqué sur l\'annonce, en toute simplicité.',
    faq3q: 'Dois-je créer un compte ?',
    faq3a: 'Non, la consultation et le contact sont possibles sans compte. Créer un compte vous permet de sauvegarder vos favoris et de laisser des avis.',
    faq4q: 'Comment publier une annonce ?',
    faq4a: 'Écrivez-nous via WhatsApp ou email : nous vous accompagnons pour mettre votre bien en ligne rapidement.',
  },

  // Politique de confidentialité
  privacy: {
    title: 'Politique de confidentialité',
    lastUpdated: 'Dernière mise à jour : 5 juillet 2026',
    intro: 'Fynho respecte votre vie privée. Cette politique explique quelles données nous collectons, comment nous les utilisons, et vos droits.',
    section1Title: '1. Données que nous collectons',
    section1Location: 'Localisation (GPS) : nous demandons l\'accès à votre position uniquement pour vous montrer les annonces à proximité sur la carte. Cette donnée n\'est jamais stockée de façon permanente ni partagée.',
    section1Account: 'Compte utilisateur : si vous créez un compte, nous collectons votre nom, votre numéro de téléphone et/ou email, et votre mot de passe (chiffré).',
    section1Content: 'Contenu publié : si vous publiez une annonce, nous stockons le titre, la description, le prix, les photos, la localisation du bien et vos coordonnées.',
    section1Usage: 'Données d\'utilisation : nous pouvons collecter des informations basiques sur l\'utilisation de l\'application pour améliorer le service.',
    section2Title: '2. Comment nous utilisons vos données',
    section2Text: 'Afficher les annonces pertinentes selon votre position, vous permettre de publier et gérer vos annonces, vous permettre de contacter les propriétaires via WhatsApp, et améliorer la qualité de l\'application. Nous ne vendons jamais vos données.',
    section3Title: '3. Partage des données',
    section3Text: 'Vos données ne sont partagées qu\'avec le propriétaire d\'une annonce, si vous choisissez de le contacter. Aucun autre tiers, sauf obligation légale.',
    section4Title: '4. Sécurité',
    section4Text: 'Vos données sont stockées sur des serveurs sécurisés. Les mots de passe sont chiffrés. Les communications sont protégées par HTTPS.',
    section5Title: '5. Vos droits',
    section5Text: 'Vous pouvez consulter, modifier vos informations, ou supprimer votre compte et toutes vos données associées à tout moment.',
    section6Title: '6. Suppression de compte',
    section6Text: 'Pour supprimer votre compte, utilisez le bouton "Supprimer mon compte" dans les paramètres, ou contactez-nous à support@fynho.com. Votre demande sera traitée sous 30 jours maximum.',
    section7Title: '7. Enfants',
    section7Text: 'Fynho ne s\'adresse pas aux enfants de moins de 13 ans. Nous ne collectons pas sciemment de données concernant des mineurs.',
    section8Title: '8. Modifications',
    section8Text: 'Nous pouvons mettre à jour cette politique de temps à autre. Toute modification importante vous sera notifiée dans l\'application.',
    contactTitle: 'Contact',
    contactText: 'Pour toute question concernant cette politique ou vos données personnelles :',
  },

  // Suppression de compte
  deleteAccount: {
    title: 'Supprimer mon compte',
    warning: 'Cette action est irréversible.',
    warningText: 'Toutes vos données seront définitivement supprimées : profil, favoris, avis, et annonces publiées.',
    confirmLabel: 'Tapez "SUPPRIMER" pour confirmer',
    confirmPlaceholder: 'SUPPRIMER',
    confirmButton: 'Supprimer définitivement mon compte',
    cancelButton: 'Annuler',
    success: 'Votre compte a été supprimé avec succès.',
    error: 'Erreur lors de la suppression. Réessayez ou contactez le support.',
    passwordRequired: 'Veuillez entrer votre mot de passe pour confirmer',
  },
  
    getApp: {
      button: 'Obtenir l\'application',
      ios: {
        step0Title: 'Ouvre le menu de Safari',
        step0Text: 'Appuie sur le bouton "•••" en bas de l\'écran.',
        step1Title: 'Appuie sur Partager',
        step1Text: 'L\'option "Partager" apparaît dans le menu, appuie dessus.',
        step2Title: 'Le menu de partage s\'ouvre',
        step2Text: 'Fais défiler vers le bas pour voir plus d\'options.',
        step3Title: 'Trouve "Sur l\'écran d\'accueil"',
        step3Text: 'Continue à faire défiler jusqu\'à voir cette option, puis appuie dessus.',
        step4Title: 'Appuie sur Ajouter',
        step4Text: 'Confirme en haut à droite pour terminer l\'installation.',
        finalTitle: 'Fynho est maintenant sur ton écran d\'accueil',
        finalText: 'Ouvre Fynho depuis son icône comme une application.',
      },
   
    android: {
      title: 'Installer Fynho sur Android',
      subtitle: 'Télécharge l\'application et installe-la en quelques étapes simples.',
      downloadButton: 'Télécharger Fynho',
      stepsTitle: 'Après le téléchargement',
      step1: 'Ouvre le fichier Fynho téléchargé',
      step2: 'Autorise l\'installation si Android te le demande',
      step3: 'Appuie sur Installer',
      step4: 'Ouvre Fynho',
    },
  },
};

export default fr;